import React from 'react';

import {
    SectionTitle,
} from 'wanderu-components';
import {
    localize,
} from 'wanderu-i18n';

import TwoColumnLayout, {
    LeftColumn,
} from '../TwoColumnLayout/TwoColumnLayout';

import styles from './SearchSection.scss';

function SearchSection(props) {
    const {
        t,
        className,
    } = props;

    return (
        <section
            aria-labelledby="gta-search"
            className={className}
            role="region"
        >
            <TwoColumnLayout className={styles.searchSection}>
                <LeftColumn className={styles.leftColumn}>
                    <div className={styles.leftColumnContent}>
                        <SectionTitle
                            className={styles.title}
                            id="gta-search"
                        >
                            {t('Search')}
                        </SectionTitle>
                        <p className={styles.text}>
                            {t('search-section-text')}
                        </p>
                    </div>
                </LeftColumn>
            </TwoColumnLayout>
        </section>
    );
}

export {
    SearchSection,
};
export default localize(SearchSection, ['t'], 'baseApp');
